import { jsx } from "react/jsx-runtime";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { validateTidalLicense } from "../../base/index.js";
function HeadsetMic(props) {
  return /* @__PURE__ */ jsx(
    HeadsetMicIcon,
    {
      "data-testid": "HeadsetMic",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "HeadsetMic",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
HeadsetMic.tidalIconMeta = {
  categories: "chat,customerService",
  name: "HeadsetMic"
};
validateTidalLicense();
export {
  HeadsetMic
};
//# sourceMappingURL=HeadsetMic.js.map
